// registrationReducer.js

// Action Types
const SET_Docusign_DATA = 'SET_Docusign_DATA';

// Action Creators
export const setDocusignData = (data) => ({
    type: SET_Docusign_DATA,
    payload: data,
});

// Initial State
const initialState = {
    docusignData: {},  // Initial empty object for storing the response data
};

// Reducer Function
const docusignReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_Docusign_DATA:
            return {
                ...state,
                docusignData: action.payload,  // Store the complete response data
            };
        default:
            return state;
    }
};

export default docusignReducer;
